<div class="header-info bg-white p-4 rounded-lg shadow-sm border">
  <div class="form">
    <div class="row">
      <div class="col-12 col-lg-6">
        <!-- Einsatznummer -->
        <div class="form-group">
          <label class="form-label" for="einsatznummer">Einsatznummer</label>
          <div *ngIf="!isFieldEditable('einsatznummer')" class="detail-value">
            {{ kontrolltermin.einsatznummer || '-' }}
          </div>
          <input
            *ngIf="isFieldEditable('einsatznummer')"
            type="text"
            class="form-control"
            id="einsatznummer"
            [value]="kontrolltermin.einsatznummer"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            readonly />
        </div>

        <!-- Standort -->
        <div class="form-group">
          <label class="form-label" for="standort">Standort</label>
          <div *ngIf="!isFieldEditable('standort')" class="detail-value">
            {{ kontrolltermin.standort?.name || '-' }}
          </div>
          <input
            *ngIf="isFieldEditable('standort')"
            type="text"
            class="form-control"
            id="standort"
            [value]="kontrolltermin.standort?.name"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            readonly />
        </div>

        <!-- Datum -->
        <div class="form-group">
          <label class="form-label" for="datum">Datum</label>
          <div *ngIf="!isFieldEditable('datum')" class="detail-value">
            {{ kontrolltermin.datum_durchfuerung | date:'dd.MM.yyyy' || '-' }}
          </div>
          <input
            *ngIf="isFieldEditable('datum')"
            type="date"
            class="form-control"
            id="datum"
            [value]="kontrolltermin.datum_durchfuerung | date:'yyyy-MM-dd'"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            readonly />
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <!-- Status -->
        <div class="form-group">
          <label class="form-label" for="status">Status</label>
          <div class="detail-value">
            {{ kontrolltermin.status?.beschreibung || '-' }}
          </div>
        </div>

        <!-- Techniker -->
        <div class="form-group">
          <label class="form-label" for="techniker">Techniker</label>
          <div *ngIf="!isFieldEditable('techniker')" class="detail-value">
            {{ kontrolltermin.techniker?.full_name || '-' }}
          </div>
          <input
            *ngIf="isFieldEditable('techniker')"
            type="text"
            class="form-control"
            id="techniker"
            [value]="kontrolltermin.techniker?.full_name"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            readonly />
        </div>

        <!-- Time Fields (if enabled) -->
        <div *ngIf="showTimeFields">
          <!-- Soll-Zeit -->
          <div class="form-group">
            <label class="form-label" for="soll_zeit">Soll-Zeit (Minuten)</label>
            <div *ngIf="!isFieldEditable('soll_zeit')" class="detail-value">
              {{ kontrolltermin.soll_zeit || '-' }} Min
            </div>
            <input
              *ngIf="isFieldEditable('soll_zeit')"
              type="number"
              class="form-control"
              id="soll_zeit"
              [value]="kontrolltermin.soll_zeit"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              readonly />
          </div>

          <!-- Ist-Zeit -->
          <div class="form-group">
            <label class="form-label" for="ist_zeit">Ist-Zeit (Minuten)</label>
            <div *ngIf="!isFieldEditable('ist_zeit')" class="detail-value">
              {{ kontrolltermin.ist_zeit || '-' }} Min
            </div>
            <input
              *ngIf="isFieldEditable('ist_zeit')"
              type="number"
              class="form-control"
              id="ist_zeit"
              [value]="kontrolltermin.ist_zeit"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              readonly />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>